var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.00391C4.13438 1.00391 1 4.13828 1 8.00391C1 11.8695 4.13438 15.0039 8 15.0039C11.8656 15.0039 15 11.8695 15 8.00391C15 4.13828 11.8656 1.00391 8 1.00391ZM8.5 11.3789C8.5 11.4477 8.44375 11.5039 8.375 11.5039H7.625C7.55625 11.5039 7.5 11.4477 7.5 11.3789V7.12891C7.5 7.06016 7.55625 7.00391 7.625 7.00391H8.375C8.44375 7.00391 8.5 7.06016 8.5 7.12891V11.3789ZM8 6.00391C7.80374 5.9999 7.61687 5.91912 7.47948 5.77891C7.3421 5.63869 7.26515 5.45021 7.26515 5.25391C7.26515 5.0576 7.3421 4.86912 7.47948 4.72891C7.61687 4.58869 7.80374 4.50791 8 4.50391C8.19626 4.50791 8.38313 4.58869 8.52052 4.72891C8.6579 4.86912 8.73485 5.0576 8.73485 5.25391C8.73485 5.45021 8.6579 5.63869 8.52052 5.77891C8.38313 5.91912 8.19626 5.9999 8 6.00391Z",
    fill: "#0070BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfos);
export default __webpack_public_path__ + "static/media/infos.7d7c7463d0b9c9c4dab943e63b1b17a3.svg";
export { ForwardRef as ReactComponent };